import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  container: {
    position: 'fixed',
    bottom: 10,
    left: 10,
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    borderRadius: 5,
    boxShadow: '2px 2px 4px rgba(0,0,0, 0.5)'
  },
  text: {
    color: 'white',
    marginRight: 5
  },
  syncBtn: {
    '& .MuiIcon-root, .MuiCircularProgress-root': {
      color: 'white'
    }
  }
}));
